import React from "react";

import FormSection from "../../Components/Document/FormSection";

const FirstStep = () => {
  return (
    <>
      <FormSection />
    </>
  );
};

export default FirstStep;
